<template>
  <div>
    <div style="width:1280px">
      <img :src="adminIntro1" usemap="#map" name="adminIntro1" />
      <div align="center">
        <object
          type="text/html"
          width="950"
          height="600"
          data="//player.vimeo.com/video/422716930?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
          allowfullscreen
        ></object>
      </div>
      <img :src="adminIntro2" usemap="#map2" name="adminIntro2" class="mb-10" />
      <div align="center">
        <object
          type="text/html"
          width="950"
          height="600"
          data="//player.vimeo.com/video/420987404?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
          allowfullscreen
        ></object>
      </div>
      <img :src="adminIntro3" usemap="#map3" name="adminIntro3" />

      <map name="map">
        <area
          shape="rect"
          coords="419,2479,868,2532"
          v-bind:href="`/authservice/${$store.state.mallId}/warrantyPeriod`"
          target="_blank"
        />
        <area
          shape="rect"
          coords="419,3374,868,3432"
          v-bind:href="`/authservice/${$store.state.mallId}/createAuthcode`"
          target="_blank"
        />
        <area
          shape="rect"
          coords="420,4571,867,4623"
          style="cursor: pointer;"
          @click.prevent="
            checkVersionAlret(`/authservice/${$store.state.mallId}/printqr`)
          "
          target="_blank"
        />
        <area
          shape="rect"
          coords="417,4832,869,4888"
          v-bind:href="`/authservice/${$store.state.mallId}/manageAuthcode`"
          target="_blank"
        />
      </map>

      <map name="map2">
        <area
          shape="rect"
          coords="420,627,871,676"
          v-bind:href="`/authservice/${$store.state.mallId}/setting`"
          target="_blank"
        />
      </map>
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data: () => ({
    adminIntro1: require("../../../assets/authservice/images/adminServiceInfo1.png"),
    adminIntro2: require("../../../assets/authservice/images/adminServiceInfo2.png"),
    adminIntro3: require("../../../assets/authservice/images/adminServiceInfo3.png"),
  }),
  mixins: [CommonMixin],
  created: function() {},
  methods: {
    moveIntro: function() {
      let route = this.$router.resolve({
        path: `/authservice/${this.$store.state.mallId}/serviceIntro`,
      });
      window.open(route.href, "_blank");
    },
    checkVersionAlret: function(url) {
      if (this.$store.state.mode !== AUTH_SERVICE.APP_MODE.PLUS) {
        let msg =
          "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
        this.alertShow(msg);
      } else {
        window.open(url, "_blank");
      }
    },
  },
  mounted: async function() {
    try {
      let data = await M.api(M.entry("/get/store"));
      if (data && data.primary_domain) {
        sessionStorage.setItem(
          `${this.$store.state.mallId}_domain`,
          data.primary_domain
        );
      }
    } catch (e) {
      console.log(e);
    }
  },
};
</script>
